import React from 'react';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';

const EditButton = ({ onClick, disabled = false, sx = {}, ...props }) => {
  return (
    <IconButton
      color="primary"
      onClick={onClick}
      disabled={disabled}
      sx={{
        '&:hover': { bgcolor: '#eaf6ff' },
        borderRadius: 2,
        ...sx,
      }}
      {...props}
    >
      <EditIcon />
    </IconButton>
  );
};

export default EditButton;
